import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {listProfiles, type AccumProfile} from './LFCPgHistoryAccumUtil';

/** 分類ルール（差分の除外行・揮発値ルールに使う）を取得する。取得前・失敗時は null */
export const usePgHistoryProfiles = (): AccumProfile[] | null => {
  const {t} = useTranslation();
  const [profiles, setProfiles] = useState<AccumProfile[] | null>(null);

  useEffect(() => {
    let active = true;
    // 取得できなくてもルールを使わないだけなので、エラーは通知しない
    listProfiles({t, snack: () => 0})
      .then(document => {
        if (active && Array.isArray(document?.profiles)) setProfiles(document.profiles);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [t]);

  return profiles;
};
